// Worley (cellular) noise primitive — cobblestone's mortar-groove generator.
export const WORLEY_GLSL = `
struct WorleySample { float f1; float f2; int cellID; float edgeDist; };

// 2D worley noise on a unit lattice.  p in cell units; jitter 0..1 controls feature-point
// displacement.  edgeDist = clamp(F2 - F1, 0, 1): ~1 at feature points (stone centres),
// ~0 at cell boundaries (mortar grooves).  cellID = hash of the nearest feature's cell.
WorleySample worleySample(vec2 p, float jitter) {
  vec2 cell = floor(p);
  float f1 = 1e10;
  float f2 = 1e10;
  ivec2 bestCell = ivec2(0);
  for (int dy = -1; dy <= 1; dy++) {
    for (int dx = -1; dx <= 1; dx++) {
      ivec2 c = ivec2(cell) + ivec2(dx, dy);
      uvec2 uc = uvec2(c);
      vec2 j = (vec2(hash01(uvec2(uc.x + 91u, uc.y + 47u)), hash01(uvec2(uc.x + 37u, uc.y + 83u))) - 0.5) * jitter;
      vec2 fp = vec2(c) + vec2(0.5) + j;
      float d = length(p - fp);
      if (d < f1) {
        f2 = f1;
        f1 = d;
        bestCell = c;
      } else if (d < f2) {
        f2 = d;
      }
    }
  }
  WorleySample s;
  s.f1 = f1;
  s.f2 = f2;
  // bestCell is an ivec2 (signed world lattice) so this is already a well-defined
  // two's-complement bitcast, NOT the undefined negative-float->uint conversion that caused
  // dirt's pebble row-lock (see Scatter.glsl.ts).  Kept explicit so the distinction is obvious.
  s.cellID = int(hash01(uvec2(bestCell)) * 1000000.0);
  s.edgeDist = clamp(f2 - f1, 0.0, 1.0);
  return s;
}
`;
